interface ErrorDetail {
  field: string;
  message: string;
}

export interface ErrorResponse {
  type: 'errorResponse';
  clientRequestId: string;
  apiTraceId: string;
  responseType: string;
  error: {
    code: string; //"INVALID_INPUT"
    message: string;
    details?: ErrorDetail[];
  };
}

/**
 {
   "type": "errorResponse",
   "clientRequestId": "6b801095-ab4e-4387-b3da-6dbf7429e320",
   "apiTraceId": "aHYe4AYWyunisxCWwkYrnQAAAsk",
   "responseType": "BadRequest",
   "error": {
   "code": "INVALID_INPUT",
   "message": "Invalid request input. Please see details below.",
   "details": [
       {
         "field": "paymentType",
         "message": "Service config 'allowPartialReversal' missing for payment type CREDITCARD"
       }
    ]
  }
 }
 */